import { Check, Close, ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { useFormikContext, FormikErrors, FormikTouched } from 'formik';
import { Fragment, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import {
  RegistrationWidowhoodFormVM,
  Widowhood as WidowhoodVM,
} from 'mutation/view-models/registration-widowhood';
import AccordionWidowhoodForm from './form';

const Widowhood = (): React.ReactElement => {
  const [open, setOpen] = useState(false);

  const formContext = useFormikContext<RegistrationWidowhoodFormVM>();

  const onFieldWidowhoodChange = useEventCallback(
    (key: keyof WidowhoodVM, value: WidowhoodVM[keyof WidowhoodVM]) => {
      formContext.setFieldValue('widowhood', {
        ...formContext.values.widowhood,
        [key]: value,
      });
    }
  );

  // changes values
  const onFieldWidowhoodChanges = useEventCallback((value: WidowhoodVM) => {
    formContext.setValues({
      ...formContext.values,
      widowhood: {
        ...formContext.values.widowhood,
        ...value,
      },
    });
  });

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-person-content"
          id="panel-person-header"
          expandIcon={<ExpandMore />}
        >
          {formContext.errors.widowhood ? <Close color="error" /> : <Check color="success" />}
          <Typography>Vedovanza</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <AccordionWidowhoodForm
            values={formContext.values.widowhood}
            onChange={onFieldWidowhoodChange}
            onChangeValues={onFieldWidowhoodChanges}
            errors={formContext.errors.widowhood as FormikErrors<WidowhoodVM>}
            touched={formContext.touched.widowhood as unknown as FormikTouched<WidowhoodVM>}
          />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

Widowhood.displayName = 'Accordion Widowhood component';

export default Widowhood;
